import React, { useEffect } from 'react';
import { useState } from 'react';

export const Tab = ({
  data,
  tabSelect = '',
  actionTab,
  type,
  cy
}) => {
  const [tabState, setTabState] = useState([]);
  const [tabStateId, setTabStateId] = useState("");

  useEffect(() => {
    if (data) {
      const selectTab = data.filter(
        (e) => e.id === (tabSelect ? tabSelect : data[0].id)
      );

      if (selectTab.length) {
        setTabState(selectTab[0].content);
        setTabStateId(selectTab[0].id);
      }
    }
  }, [data]);

  return (
    <div
      className={type === 'custom' ? 'custom-tab' : 'box-tab'}
      data-cy={cy}
    >
      <div className="tab-head">
        {data?.map((e) => (
          <div
            key={e.id}
            data-cy={cy ? `${cy}-item` : undefined}
            data-cy-key={cy ? e.id : undefined}
            data-cy-selected={
              cy
                ? (e.id === tabStateId ? 'true' : 'false')
                : undefined
            }
            className={e.id === tabStateId ? 'active' : ''}
            onClick={() => [
              setTabStateId(e.id),
              setTabState(e.content),
              actionTab(e.id),
            ]}
          >
            {e.title}
          </div>
        ))}
      </div>

      <div
        className="tab-content"
        data-cy={cy ? `${cy}-content` : undefined}
        data-cy-key={cy ? tabStateId : undefined}
      >
        {tabState}
      </div>
    </div>
  );
};